<template>
  <DialogContent
    class="mt-2 tablet-h:mt-4 flex flex-col items-center text-center"
  >
    <DacrBadge class="size-[82px] mb-5" :icon-size="56" />
    <div class="font-semibold text-[34px] leading-10 text-gray-800 mb-5">
      View this private copyright
    </div>
    <div
      class="font-secondary text-[16px] leading-[24px] text-gray-500 max-w-[266px] mb-[30px]"
    >
      Sign in or create a Dacr account to access this copyright
    </div>
    <UiButton
      class="w-full! tablet-h:w-auto! mb-[18px]"
      primary
      large
      @click="handleCreateAccountClick"
    >
      Create an account
    </UiButton>
    <div>
      Have an account?
      <span class="font-medium text-link" @click="handleSignInClick">
        Sign in
      </span>
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import DacrBadge from '@/shared/components/DacrBadge.vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  email: string
}>()

const { close } = useDialog()
const router = useRouter()

const handleCreateAccountClick = () => {
  router.push(`/register?email=${props.email}`)
  close()
}

const handleSignInClick = () => {
  router.push('/login')
  close()
}
</script>
